import { Injectable } from "@angular/core";
import * as FileSaver from "file-saver";
import * as ExcelJS from "exceljs/dist/exceljs.min.js";
import { first } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ExcelExportService {
  constructor() {
    //do nothing, leave comment to avoid sonar error
  }

  fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  fileExtension = ".xlsx";

  public async exportToExcel(jsonData: any[], fileName: string): Promise<void> {
    const fName = this.appendTimeStamp(fileName);

    // Create a new workbook and a new worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Data");

    //Grab columns from keys of first element in jsonData
    const columns =
      jsonData !== null && typeof jsonData === "object"
        ? Object.keys(jsonData[Object.keys(jsonData)[0]])
        : null;
    let columnsWithIDs = [];
    if (columns !== null) {
      columnsWithIDs = columns.map((column) => {
        return { header: column, key: column };
      });
    }

    //Set title
    const colCountToMerge = columns.length;
    const colRangeEnd = this.intToCol(colCountToMerge);
    const mergeString = "A1:" + colRangeEnd + "1";
    worksheet.mergeCells(mergeString);
    worksheet.getCell("A1").font = {
      bold: true,
      size: 16,
      color: { argb: "ffffff" },
    };
    worksheet.getCell("A1").fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "ff0066cc" },
    };

    // Add columns to the worksheet
    worksheet.addRow(columns);
    worksheet.columns = columnsWithIDs;

    //Set title over
    worksheet.getCell("A1").value = fileName;

    // Add rows to the worksheet
    worksheet.addRows(jsonData);

    // Write the workbook to a buffer
    const buffer = await workbook.xlsx.writeBuffer();

    this.saveExcelFile(buffer, fName);
  }

  private saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.fileType });
    FileSaver.saveAs(data, fileName);
  }

  public exportToExcelFromServer(buffer, filename) {
    this.saveExcelFile(
      buffer,
      this.appendTimeStamp(filename) + this.fileExtension
    );
  }

  private appendTimeStamp(fileName) {
    let fName = fileName;
    const dateStamp = new Date();
    fName = fName.replace(" ", "_");

    fName = fName.concat("_");
    fName = fName.concat(dateStamp.getFullYear().toString());
    fName = fName.concat("-");
    fName = fName.concat((dateStamp.getMonth() + 1).toString());
    fName = fName.concat("-");
    fName = fName.concat(dateStamp.getDate().toString());
    fName = fName.concat("T");
    fName = fName.concat(dateStamp.getHours().toString());
    fName = fName.concat(":");
    fName = fName.concat(dateStamp.getMinutes().toString());
    fName = fName.concat(":");
    fName = fName.concat(dateStamp.getSeconds().toString());

    return fName;
  }

  private intToCol(i: number) {
    let column = "";
    while (i > 0) {
      const remainder = (i - 1) % 26;
      column = String.fromCharCode(65 + remainder) + column;
      i = Math.floor((i - remainder) / 26);
    }
    return column;
  }
}
